import router from '@/router';
import Router from 'vue-router';
const { isNavigationFailure, NavigationFailureType } = Router;

export const changeQuery = async (newQuery = {}) => {
  try {
    let query = Object.assign({}, router.currentRoute.query);
    await router.replace({
      query: {
        ...query,
        ...newQuery,
      },
    });
  } catch (error) {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throw Error(error);
    }
  }
};

export const deleteQuery = async (queries = []) => {
  let replaceRouter = false;
  let query = Object.assign({}, router.currentRoute.query);
  queries.forEach((queryToDelete) => {
    if (query[queryToDelete] && !replaceRouter) replaceRouter = true;
    delete query[queryToDelete];
  });
  if (replaceRouter)
    await router.replace({
      query,
    });
};
